export default "__VITE_ASSET__3KPZD4ka__"